import { NibbleAction } from '@aipb/personal-content/shared/model';
import { openUrl } from '@aipb/util/routing';
import { NibbleActionHandler } from '../nibble-action.handler';

export class LinkNibbleActionHandler implements NibbleActionHandler {
  handle(nibbleAction: NibbleAction) {
    const serviceValue = nibbleAction.nibbleCut.cut.serviceValue;
    openUrl(serviceValue);
  }

  getUrl(nibbleAction: NibbleAction): string {
    return nibbleAction.nibbleCut.nibble.userValue;
  }

  useResolver(): boolean {
    return false;
  }
}
